import * as login from "./login";
import * as job from "./job";

export default {
  ...login,
  ...job,
};
